<template>
  <span :class="{ 'bg-gray-200': !model, 'bg-gray-800': model }"
        class="relative inline-block flex-shrink-0 h-6 w-14 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:shadow-outline"
        role="checkbox"
        tabindex="0"
        @click="triggerToggle"
        @keydown.space.prevent="triggerToggle"
        :aria-checked="model">
  <span aria-hidden="true"
        :class="{ 'translate-x-8': model, 'translate-x-0': !model }"
        class="inline-block h-5 w-5 rounded-full bg-white shadow transform transition ease-in-out duration-200">
  </span>
</span>
</template>
<script>
  export default {
    name: 'base-switch',
    props: {
      value: {
        type: [Array, Boolean, String, Number],
        description: 'Switch value'
      },
      disabled: {
        type: [Boolean, String],
        description: 'Whether switch is disabled'
      },
    },
    computed: {
      model: {
        get () {
          if (typeof this.value === 'string') {
            return this.value === '1'
          }
          return this.value
        },
        set (value) {
          if (typeof this.value === 'string') {
            this.$emit('input', value ? '1' : '0')
          } else {
            this.$emit('input', value)
          }
        }
      }
    },
    methods: {
      triggerToggle (evt) {
        if (evt) {
          evt.stopPropagation()
        }
        this.model = !this.model
      }
    }
  }
</script>
<style>
</style>
